import * as i0 from "@angular/core";
export class SignupHeaderStore {
}
SignupHeaderStore.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function SignupHeaderStore_Factory() { return new SignupHeaderStore(); }, token: SignupHeaderStore, providedIn: "root" });
export var SignupHeaderStoreKeys;
(function (SignupHeaderStoreKeys) {
})(SignupHeaderStoreKeys || (SignupHeaderStoreKeys = {}));
